import { render, staticRenderFns } from "./rolelist.vue?vue&type=template&id=08143669&scoped=true&"
import script from "./rolelist.vue?vue&type=script&lang=js&"
export * from "./rolelist.vue?vue&type=script&lang=js&"
import style0 from "./rolelist.vue?vue&type=style&index=0&id=08143669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08143669",
  null
  
)

export default component.exports